var _div;
import Search from '@crehana/compass.icons.outline/Search';
import { useTranslation } from '@crehana/i18n';
import locales from "../i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TableEmptySearch = function TableEmptySearch(_ref) {
  var searchKey = _ref.searchKey;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var t = locales[languageCode];
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-0.8",
    children: [_div || (_div = /*#__PURE__*/_jsx("div", {
      className: "tw-flex tw-items-center tw-justify-center tw-rounded-full tw-w-[6rem] tw-aspect-square tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-700",
      children: /*#__PURE__*/_jsx(Search, {
        className: "tw-text-neutral-light-600 dark:tw-text-neutral-dark-200",
        size: 24
      })
    })), /*#__PURE__*/_jsxs("div", {
      className: "tw-font-subtitle5 tw-text-neutral-light-800 dark:tw-text-neutral-light-100",
      children: [/*#__PURE__*/_jsx("p", {
        children: t.TABLE_STATE_EMPTY_SEARCH_TITLE
      }), /*#__PURE__*/_jsxs("p", {
        children: ["\"", /*#__PURE__*/_jsx("span", {
          className: "tw-text-primary-light-500 dark:tw-text-secondary-dark-500",
          children: searchKey
        }), "\""]
      })]
    }), /*#__PURE__*/_jsx("p", {
      className: "tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-500",
      children: t.TABLE_STATE_EMPTY_SEARCH_SUBTITLE
    })]
  });
};